import { navigate } from 'gatsby';
import React, { memo, useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ErrorBoundary from '../components/shared/ErrorBoundary';
import Hero from '../components/landing/Hero';
import Wrapper from '../components/shared/Wrapper';
import UserContext from '../contexts/UserContext';

const Home = () => {
  const { user, loginWithGoogle } = useContext(UserContext);

  const handleLogin = async () => {
    await loginWithGoogle();
    navigate('/app');
  };

  useEffect(() => {
    if (user) {
      navigate('/app');
    }
  }, [user]);

  return (
    <ErrorBoundary
      FallbackComponent={
        <p>Seems like an error occurred. Please refresh and try again</p>
      }
    >
      <Wrapper>
        <Helmet>
          <title>Yes Resume Builder</title>
          <link rel="canonical" href="/" />
        </Helmet>
        <div className="container h-screen">
          <Hero handleLogin={handleLogin} />
        </div>
      </Wrapper>
    </ErrorBoundary>
  );
};

export default memo(Home);
